var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.$route.meta.layout,{tag:"component"},[_c('p',[_vm._v("404: Not Found")]),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.goBack}},[_vm._v(" Go back to safety! ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }